import { render, staticRenderFns } from "./date-valueFormat-editor.vue?vue&type=template&id=0ae8eb96&scoped=true&"
import script from "./date-valueFormat-editor.vue?vue&type=script&lang=js&"
export * from "./date-valueFormat-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8eb96",
  null
  
)

export default component.exports